module.exports = __webpack_public_path__ + "static/media/2024_25.653e2366.jpg";